'use client'

import * as React from 'react'
import { useTranslation } from 'react-i18next'
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { useDeletePostPurchaseRules } from '@/lib/api/postPurchaseRules'

interface DeletePostPurchaseRuleModalProps {
	ruleId?: string
	storeId: string
	onClose: () => void
}

/**
 * DeletePostPurchaseRuleModal component for confirming deletion of a single rule
 */
export const DeletePostPurchaseRuleModal = ({ ruleId, storeId, onClose }: DeletePostPurchaseRuleModalProps) => {
	const { t } = useTranslation('postPurchaseRules')
	const deleteRulesMutation = useDeletePostPurchaseRules()

	const handleDelete = async () => {
		if (!ruleId) return
		await deleteRulesMutation.mutateAsync({ storeId, ids: [ruleId] })
		onClose()
	}

	return (
		<AlertDialog open={!!ruleId} onOpenChange={onClose}>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>{t('modals.delete.title')}</AlertDialogTitle>
					<AlertDialogDescription>
						{t('modals.delete.description')}
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel onClick={onClose}>{t('actions.cancel')}</AlertDialogCancel>
					<AlertDialogAction
						onClick={handleDelete}
						disabled={deleteRulesMutation.isPending}
						className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
					>
						{deleteRulesMutation.isPending ? t('modals.delete.deleting') : t('modals.delete.delete')}
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}

